import { Box, Divider, Stack, CircularProgress, Typography, IconButton, createTheme } from "@mui/material";
import { StatCardInterface } from "../../interfaces";
import { statCardCountStyle, statCardTitleStyle } from "./StatCardStyles";
import { useScreenSize } from "../../hooks";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { useState } from "react";
import { globalTheme } from "../../styles";

export const StatCard = (props: StatCardInterface) => {
  const { title, count = 0, colorCode, bgColor, borderColor, isError, loading, refetchCardStats, error } = props;
  const { belowDesktop, belowTablet, belowPhablet } = useScreenSize();
  const [showRefresh, setShowRefresh] = useState(false);

  let stackWidth = "100%";
  if (belowDesktop) {
    stackWidth = "100%";
  } else if (belowTablet) {
    stackWidth = "50%";
  } else if (belowPhablet) {
    stackWidth = "100%";
  }

  if (!title) {
    return null;
  }
  const handleRefresh = () => {
    refetchCardStats();
  };

  return (
    <Stack
      divider={<Divider flexItem />}
      spacing={1}
      alignItems="center"
      sx={{
        border: borderColor,
        justifyItems: "center",
        padding: "24px",
        backgroundColor: bgColor,
        width: stackWidth,
      }}
    >
      <Box sx={statCardTitleStyle}>{title}</Box>
      {isError ? (
        <Stack onMouseEnter={() => setShowRefresh(true)} onMouseLeave={() => setShowRefresh(false)}>
          <Typography variant="body2" color={globalTheme.red}>
            {typeof error === "string" ? error : (error as Error).message}
          </Typography>
          <Stack>
            {showRefresh ? (
              <IconButton onClick={handleRefresh} sx={{ fontSize: "80px", color: globalTheme.red }}>
                <RefreshIcon />
              </IconButton>
            ) : (
              <PriorityHighIcon sx={{ margin: 1, fontSize: "80px", color: globalTheme.red }} />
            )}
          </Stack>
        </Stack>
      ) : (
        <Box sx={statCardCountStyle(colorCode)}>{loading ? <CircularProgress size={20} /> : count}</Box>
      )}
    </Stack>
  );
};
